import { useState } from 'react'

import { faTrash } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from 'antd'
import { Tooltip } from 'govwell-ui'
import styled from 'styled-components'

const StyledButton = styled(Button)<{ $isDestructiveOnHover?: boolean }>`
  ${({ $isDestructiveOnHover }) =>
    $isDestructiveOnHover &&
    `
    &:hover:not(:disabled) {
      color: #ef4444 !important;
      border-color: #ef4444 !important;
    }
  `}
`

interface Props {
  onClick: () => void | Promise<void>
  loading?: boolean
  tooltip?: string
  disabled?: boolean
  /** When true, the button will show red styling on hover */
  isDestructiveOnHover?: boolean
}
export const DeleteButton = (props: Props) => {
  const { onClick, loading, tooltip, disabled, isDestructiveOnHover = true } = props
  const [loadingState, setLoadingState] = useState(false)

  const button = (
    <StyledButton
      $isDestructiveOnHover={isDestructiveOnHover}
      icon={<FontAwesomeIcon icon={faTrash} />}
      type="default"
      size="small"
      disabled={disabled}
      // using onMouseDown instead of onClick to stop propagation from Plan Review <Page />
      onMouseDown={async (e) => {
        e.preventDefault()
        e.stopPropagation()
        setLoadingState(true)
        try {
          await onClick()
        } catch (error) {
          console.log(error)
        } finally {
          setLoadingState(false)
        }
      }}
      loading={loadingState || loading}
    />
  )

  if (tooltip) {
    return <Tooltip content={tooltip}>{button}</Tooltip>
  }
  return button
}
